<nz-layout class="layout" [ngClass]="{fullWidth}">
  <nz-header
    [ngClass]="{ transparent: transparent && !isBottom }"
    [ngStyle]="
      transparent && !isBottom ? { '--text-color': transparentColor } : null
    "
  >
    <un-header></un-header>
  </nz-header>
  <nz-content>
    <section class="inner-content">
      <router-outlet></router-outlet>
    </section>
  </nz-content>
  <nz-footer>
    <un-footer></un-footer>
  </nz-footer>
</nz-layout>
